import { modalUtil } from './modalUtil.js';
import router from '@/router';
import { url } from '@/config/urls';

/**
 * APIエラー処理関数
 * @param {Object} error - Axiosエラーオブジェクト
 * @param {import('vue').Ref<string[]>|null} errorMessagesRef - エラーモーダル表示用メッセージ
 */
export function apiError(error, errorMessagesRef = null) {

  // errorが存在しない、またはresponseが存在しない場合は処理しない
  if (!error || !error.response) {
    return;
  }
  const status = error?.response?.status;
  
  // modalUtilを使用
  const { switchFromCurrentModal } = modalUtil();

  // エラーモーダルを表示する関数
  const showErrorModal = (messages) => {
    const messageArray = Array.isArray(messages) ? messages : [messages];
    
    // リアクティブなrefが渡された場合、それを更新
    if (errorMessagesRef?.value !== undefined) {
      errorMessagesRef.value = messageArray;
    }
    
    if(messageArray.length > 0) {
      // 現在表示されているモーダルがあれば切り替え、なければ直接表示
      switchFromCurrentModal('apiErrorModal');
    }
  };
  

  switch (status) {
    case 400:
      // 400エラーはモーダル表示
      const messagesSet = new Set();
      if(error.response?.data?.error) {
        for(const e of error.response.data.error) {
          messagesSet.add(e.message);
        }
      }
      showErrorModal(
        messagesSet.size > 0 ? Array.from(messagesSet): ['入力内容に誤りがあります']);
      return;

    case 401:
      router.replace(url.login);
      return;

    case 404:
      showErrorModal(['指定されたページを表示できません。']);
      return;

    case 500:
      router.push({ path: url.error, query: { errorCode: 500 } });
      return;

    default:
      showErrorModal(['不明なエラーが発生しました。']);
      return;
  }
}
